import { TextField } from '@mui/material';
import React from 'react';

import { MobileInteractionForm } from './MobileInteractionForm';
import {
  ConfirmContent,
  ErrorMessage,
  SelectedStatusBadge,
} from './MobileStatusUpdateDialog.styles';
import { StatusSelection } from './MobileStatusUpdateDialog.props';
import { InteractionFormData, ServiceObject } from '../../../../../../@types/service.type';

interface StatusConfirmStepProps {
  selectedStatus: StatusSelection;
  notes: string;
  onNotesChange: (value: string) => void;
  error: string | null;
  interactions: InteractionFormData[];
  formValues: Record<string, any>;
  onFieldChange: (interactionId: number, fieldId: number, value: any) => void;
  onBlockBypass?: (interactionId: number, fieldId: number) => void;
  service?: ServiceObject;
}

export const StatusConfirmStep: React.FC<StatusConfirmStepProps> = ({
  selectedStatus,
  notes,
  onNotesChange,
  error,
  interactions,
  formValues,
  onFieldChange,
  onBlockBypass,
  service,
}) => {
  return (
    <ConfirmContent>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <SelectedStatusBadge>{selectedStatus.name}</SelectedStatusBadge>

      {interactions.map((interaction) => (
        <MobileInteractionForm
          key={interaction.id}
          interaction={interaction}
          formValues={formValues}
          onFieldChange={onFieldChange}
          onBlockBypass={onBlockBypass}
          service={service}
        />
      ))}

      <TextField
        fullWidth
        multiline
        rows={3}
        label="Notes (optional)"
        value={notes}
        onChange={(e) => onNotesChange(e.target.value)}
        sx={{ padding: '0 16px 16px' }}
      />
    </ConfirmContent>
  );
};
